import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { DropdownContainer, Dropdown } from '../dropdown';

class ProcedureDropdownView extends Component {
    static propTypes = {
        dropdownDataTest: PropTypes.string,
        onProcedureChange: PropTypes.func,

        procedures: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
                name: PropTypes.string,
                insuranceMayNotCover: PropTypes.bool,
            })
        ),
        selected: PropTypes.string,
        trackDropdownClick: PropTypes.func,
        trackProcedureChange: PropTypes.func,
    };

    static defaultProps = {
        onProcedureChange: noop,
        trackDropdownClick: noop,
        trackProcedureChange: noop,
    };

    render() {
        const {
            dropdownDataTest,
            procedures,
            popularProcedures,
        } = this.props;

        let proceduresToUse;
        let groupBy;

        if (popularProcedures && popularProcedures.length && procedures && procedures.length) {
            proceduresToUse = [{
                id: 'popular',
                name: 'Popular Visit Reasons',
                options: popularProcedures,
            },
            {
                id: 'all',
                name: 'All Visit Reasons',
                options: procedures,
            }];
            groupBy = 'options';
        } else if (popularProcedures && popularProcedures.length) {
            proceduresToUse = popularProcedures;
        } else if (procedures && procedures.length) {
            proceduresToUse = procedures;
        } else {
            proceduresToUse = [];
        }

        let placeholderText = 'N/A';

        if (this.props.loading) {
            placeholderText = 'Loading...';
        } else if (proceduresToUse.length) {
            placeholderText = 'Choose your reason for visit';
        }

        return (
            <DropdownContainer
                onChange={this.handleChange}
                selected={proceduresToUse.length ? this.props.selected : undefined}
            >
                <Dropdown
                    data-test={dropdownDataTest}
                    groupBy={groupBy}
                    onClick={this.props.trackDropdownClick}
                    options={proceduresToUse}
                    placeholder={placeholderText}
                    suppressPlaceholder
                />
            </DropdownContainer>
        );
    }

    handleChange = value => {
        const selectedProcedure =
            this.props.procedures.find(procedure => value === procedure.id)
         || this.props.popularProcedures.find(procedure => value === procedure.id);

        this.props.onProcedureChange(
            selectedProcedure.id,
            selectedProcedure.insuranceMayNotCover,
            selectedProcedure.name
        );
        this.props.trackProcedureChange(selectedProcedure);
    };
}

export {
    ProcedureDropdownView as default,
    ProcedureDropdownView,
};
